<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Name"
      imgName="circle">
      {{ group.name }}
    </detail-item>
    <detail-item
      name="gid"
      imgName="circle">
      {{ group.gid }}
    </detail-item>
    <detail-item
      name="uuid"
      imgName="circle">
      {{ group.uuid }}
    </detail-item>
  </div>
</template>

<script>
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'AlertLogGroup',
  components: {
    DetailItem,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
};
</script>
